import styled from 'styled-components';

export const StepsSwiperResizeListener = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const ResizingMessage = styled.div`
  left: 50%;
  opacity: 0.3;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;
